<template>
  <div class="login">
    <LoginComponent msg="Welcome to RTS 3.0"/>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginComponent from '../components/Login.vue'

export default {
  name: 'home',
  components: {
    LoginComponent
  }
}
</script>

<style>
.login {
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 9999999;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    display: table;
}
</style>
